import { EnvironmentType } from 'src/app/constants/environment-type';
import { appVersion } from './app-version';

export const environment = {
  production: true,
  type: EnvironmentType.Test,
  host: 'https://portaltest.myworkplace.net',
  api: 'https://portaltest.myworkplace.net/api',
  appVersion: appVersion,
  googleCaptchaKey: '6LcNCyYUAAAAAJS4nhkX-RZWok872P-jtJlqXBKQ',
  cloudflareCaptchaKey: '0x4AAAAAAAwo62KbUXLH0F9i',
  androidURL:
    'https://play.google.com/store/apps/details?id=mobile.myworkplace.net&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
  appleURL:
    'https://apps.apple.com/us/app/myworkplace-benefits/id1616512493?itsct=apps_box_badge&amp;itscg=30200',
  encryptionKey: 'A!t#W2pZ$9mV8^dRkQx@eLf&C3s*nY7HbgoJ',
  useWidgetTestPage: false,
  devExtremeKey:
    'LCPv1%>ag%bV+SJ<oeR+%cbeE!JmG:YdK><VoVgf8>+Xy!pmv9<!NZ%47cJ!<9YdnS<+R>i,1!7@v7b38(<mRVQ-6>R,n:jRJ%RS8SRrB9b!L3_m>7%@+:Qc[c7F%:jmE2%mXeeenZ%F36JR>:J,ee+R6Sid@>nt46n!vpJ!GS%,jZ%@Y,<-;IncmkeQ-2gXB9K9-619Bpb-G!QX<SKX<I_z->Q4E2%!F67y)>%X<2p@6p<-)!jyQaNRQpg!F6<4$27y@G<-6p<dQI%!:aQ!)27@QI%4v>jzvaj@F>Qd$>NR@!KX;I_@:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll',
};
